if (!customElements.get('product-add-ons')) {
  customElements.define(
    'product-add-ons',
    class ProductAddOns extends HTMLElement {
      constructor() {
        super();
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.form = null;
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.form = document.getElementById(`product-form-${this.sectionId}`);
        if (this.form) {
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this), { capture: true });
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        const productForm = this.form.closest('product-form');
        if (!productForm) return;

        const submitButton = productForm.querySelector('[type="submit"]');
        if (submitButton && submitButton.getAttribute('aria-disabled') === 'true') return;

        if (submitButton) {
          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');
          const spinner = submitButton.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');
        }

        this.handleErrorMessage();

        const formData = new FormData(this.form);
        const items = [];

        const mainId = formData.get('id');
        const mainQty = formData.get('quantity') || '1';
        if (mainId) {
          items.push({ id: parseInt(mainId), quantity: parseInt(mainQty) });
        }

        this.querySelectorAll('.product-add-ons__checkbox:checked').forEach((checkbox) => {
          items.push({
            id: parseInt(checkbox.dataset.addonVariantId),
            quantity: 1,
          });
        });

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        const sections = this.cart
          ? this.cart.getSectionsToRender().map((section) => section.id)
          : [];
        config.body = JSON.stringify({
          items,
          sections,
          sections_url: window.location.pathname,
        });

        fetch(`${window.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-add-ons',
                productVariantId: mainId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.querySelectorAll('.product-add-ons__checkbox:checked').forEach((cb) => {
              cb.checked = false;
            });

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-add-ons',
              productVariantId: mainId,
              cartData: response,
            }).then(() => {
              this.cart.renderContents(response);
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (submitButton) {
              submitButton.classList.remove('loading');
              submitButton.removeAttribute('aria-disabled');
              const spinner = submitButton.querySelector('.loading__spinner');
              if (spinner) spinner.classList.add('hidden');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        const productForm = this.form?.closest('product-form');
        if (!productForm) return;
        const errorWrapper = productForm.querySelector('.product-form__error-message-wrapper');
        if (!errorWrapper) return;
        const errorMsg = errorWrapper.querySelector('.product-form__error-message');
        errorWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage && errorMsg) {
          errorMsg.textContent = errorMessage;
        }
      }
    }
  );
}
